import {notNull} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {HeaderHeightCalculator} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/components/headerHeightCalculator';
import {SlRadioGroup} from '@shoelace-style/shoelace/shoelace';
import {ScrollToElement} from '../../common/scrollToElement';

/**
 * Funktionen fuer das Tariflist CmsModul
 *  - Filter ein und ausblenden
 */
export class Tariflist {
    private readonly viewRoot: HTMLElement;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;

        this.openFilterMobile();
        this.closeFilterMobile();
    }

    private openFilterMobile() {
        const openFilterButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            'form.dsl-filter .filtern, ' + '.form_moduleCms_tariflist .filtern, ' + 'form.moduleCms_offerlist .filtern',
        );

        openFilterButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                notNull(document.querySelector('body')).classList.add('no-scroll');
                notNull(document.querySelector('html')).classList.add('no-scroll');

                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const filter = cmsRoot.querySelector<HTMLElement>('.cms-tarif-list-filter');
                if (filter) {
                    filter.style.display = 'block';
                }
                const headline = cmsRoot.querySelector<HTMLElement>('.filter-mobile-headline');
                if (headline) {
                    headline.scrollIntoView();
                }
            });
        });
    }

    private closeFilterMobile() {
        // geht zu wenn man auf der close-icon oder auf die ganze filterzeile klickt
        const closeFilterButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            '.form_moduleCms_tariflist .filter-mobile-headline, ' + // man muss nicht auf das X klicken, man kann die ganze leiste klicken
                '.form_moduleCms_tariflist .closeFilter,' + // nicht das X sondern der Button im filter "Alle Tarife anzeigen"
                'form.dsl-filter .filter-mobile-headline,' +
                'form.dsl-filter .closeFilter ',
        );
        closeFilterButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                notNull(document.querySelector('body')).classList.remove('no-scroll');
                notNull(document.querySelector('html')).classList.remove('no-scroll');

                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }

                const filter = cmsRoot.querySelector<HTMLElement>('.cms-tarif-list-filter');
                if (!filter) {
                    return;
                }

                filter.style.display = 'none';
                const row = filter.closest<HTMLElement>('.row');
                if (row) {
                    new ScrollToElement(row);
                }
            });
        });
    }
}
